import React, {useState, useEffect, useRef} from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import useAxiosProtect from '../../../hooks/useAxiosProtect';
import useAuth from '../../../hooks/useAuth';
import Overview from './client_components/Overview';
import Impacts from './client_components/Impacts';
import SiteSavings from './client_components/SiteSavings';
import OrgOpportunitiesPage from './client_components/OrgOpportunitiesPage';
import UtilityTrendContainer from '../../staff_pages/utility_data/utility_trend_system/UtilityTrendContainer';

const ClientDashContainer = props => {
    const [value, setValue] = useState('sites');
    const [isLoading, setIsLoading] = useState(true);

    const [siteNames, setSiteNames] = useState([]);
    const [selectableSites, setSelectableSites] = useState([]);

    const [siteLookup, setSiteLookup] = useState({});
    const {auth, authContext} = useAuth();
    const axiosProtect = useAxiosProtect();
    
    const [errorMessage, setErrorMessage] = useState('');
    
    var init = useRef(true);
        const handleSiteSelection = e => {
            const {target: {value}} = e;
    
            // if(value.length === 0) return;
            setIsLoading(true);
    
            setSiteNames(typeof value === 'string' ? value.split(',') : value);
        }
    
        useEffect(() => {
            if(!init.current) return;
    
            axiosProtect.get(`/auth/query/list-client-site-access?uid=${auth?.id}`).then(response => {
                let siteNameArr = [];
                let siteLookupObj = {};
                for(let i = 0;i<response.data.sites.length;++i){
                    siteNameArr.push(response.data.sites[i].name)
                    siteLookupObj[response.data.sites[i].name] = response.data.sites[i].id
                }
    
                setSiteNames(siteNameArr);
                setSelectableSites(siteNameArr);
                setSiteLookup(siteLookupObj);
    
                
            }).catch(err => {setErrorMessage(err.response.data);});
        }, []);
    

    const handleChange = (value) => {
        setValue(value);
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };
    return(
        <div style={{padding:'2%', backgroundColor:'#f5f5f5', minHeight:'95vh'}}>
             
             <div style={{display:'flex', flexDirection:'row'}}>
                {/* might add this back, might change it to make it widget-based (i.e., every table, graph syste, etc, will be individually togglable) */}


                {/* <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="demo-multiple-checkbox-label">Sites</InputLabel>
                    <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={siteNames}
                    onChange={handleSiteSelection}
                    input={<OutlinedInput label="Sites" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                    >
                    {selectableSites.map(site => (
                        <MenuItem key={site} value={site}>
                            <Checkbox checked={siteNames.includes(site)} />
                            <ListItemText primary={site} />
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl> */}
            </div>
                
            {/* <Tabs defaultActiveKey="sites" className="mb-3" justify value={value} onSelect={handleChange}> */}
            {/* {!props.isMobile && <UtilityTrendContainer clientView={true}/>} */}
            <UtilityTrendContainer clientView={true} isMobile={props.isMobile}/>
            <>
            <h4 style={{textAlign: "center"}}>Glidepath</h4>
            <Impacts userData={props.userData} isMobile={props.isMobile}/>
            </>
            <>
            <h4 style={{textAlign: "center"}}>Opportunities & Project Impacts</h4>
            <OrgOpportunitiesPage userData={props.userData} isMobile={props.isMobile}/>
            </>

            {/* <Tabs defaultActiveKey="sites" className="mb-3" justify value={value} onSelect={handleChange}>
                <Tab value = 'impacts' eventKey="impacts" title="Savings"/>
                <Tab value = 'opportunities' eventKey="opportunities" title="Opportunities"/>
                <Tab value = 'sites' eventKey="sites" title="Sites"/>
            </Tabs>

            {value === 'impacts' && <Impacts userData={props.userData}/>}
            {value === 'opportunities' && <OrgOpportunitiesPage userData={props.userData}/>}
            {value === 'sites' && <Overview userData={props.userData}/>}
            {value === 'sites' && <Overview userData={props.userData}/>} */}
            {/* {value === 'sites' && <SiteSavings userData={props.userData}/>} */}
        </div>
    );
}

export default ClientDashContainer;